import { createContext } from "react";

const alumniContext = createContext();

export default alumniContext;